import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 16px;
  align-items: end;
`;

export const InputContainer = styled.div`
  flex: 1;
  max-width: 100%;
`;

export const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`;

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  height: 48px;
  padding: 0 16px;
  font-size: 18px;
  border: 2px solid ${props => (props.hasError ? "#e53e3e" : "#d1d5db")};
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: ${props => (props.hasError ? "#e53e3e" : "#395ca3")};
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const SearchButton = styled.button<{ disabled?: boolean }>`
  height: 48px;
  padding: 0 32px;
  background-color: ${props => (props.disabled ? "#9ca3af" : "#395ca3")};
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${props => (props.disabled ? "#9ca3af" : "#33508b")};
  }
`;

export const SmallContainer = styled.div`
  display: flex;
  gap: 8px;
`;

export const SmallInput = styled.input<{ hasError?: boolean }>`
  flex: 1;
  height: 36px;
  padding: 0 12px;
  font-size: 14px;
  width: 100%;
  border: 1px solid ${props => (props.hasError ? "#e53e3e" : "#d1d5db")};
  border-radius: 4px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: ${props => (props.hasError ? "#e53e3e" : "#395ca3")};
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const SmallButton = styled.button`
  height: 36px;
  width: 36px;
  background-color: #395ca3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;

  &:hover {
    background-color: #33508b;
  }
`;

export const ErrorMessage = styled.div`
  color: #e53e3e;
  font-size: 12px;
  margin-top: 4px;
`;
